import styled, { css } from "styled-components"
import CloseIcon from "components/atoms/CloseIcon"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${({ theme }) => theme.mq.extraLarge} {
    max-width: 140rem;
    max-height: 80rem;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
const StyledContentWrapper = styled.div`
  flex: 1;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0;
    overflow: hidden;
  }
`
const StyledFormFooterWrapper = styled.div`
  width: 100%;
  position: sticky;
  bottom: 0;
  height: 8.8rem;
  background-color: ${({ theme }) => theme.color.white};
  border-top: 1px solid ${({ theme }) => theme.color.secondary04};
  z-index: 2;

  ${({ theme }) => theme.mq.medium} {
    position: fixed;
    height: 10.4rem;
  }
`

const StyledButtonWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.layout.mobilePadding};
  display: flex;
  height: 100%;
  margin: 0 auto;
  align-items: center;

  ${({ theme }) => theme.mq.medium} {
    max-width: ${({ theme }) => theme.gridWidth};
    justify-content: flex-end;
  }
`
const buttonStyles = css`
  min-height: 4rem;
  height: 4rem;
  padding: 0 2.4rem;
  font-size: ${({ theme }) => theme.font.size.s};

  &:disabled {
    opacity: 0.8;
  }

  ${({ theme }) => theme.mq.medium} {
    min-height: 5.6rem;
    padding: 0 3.2rem;
    font-size: 1.6rem;
  }
`

const secondaryButton = css`
  ${buttonStyles}
  margin: 0 0.8rem 0 auto;

  ${({ theme }) => theme.mq.medium} {
    margin: 0 1.6rem 0 24.8rem;
  }
`
const StyledSuccessWrapper = styled.div`
  > h2,
  p {
    margin-bottom: 1.6rem;
  }
  padding: 8rem ${({ theme }) => theme.layout.mobilePadding} 0;
  ${({ theme }) => theme.mq.medium} {
    padding: 11.6rem;
  }
`

const StyledCloseButton = styled.div`
  position: absolute;
  top: 2.8rem;
  left: 1.6rem;
  border: none;
  background: none;
  width: 1.6rem;
  height: 1.6rem;
  margin-left: auto;
  cursor: pointer;
  z-index: 102;

  ${({ theme }) => theme.mq.medium} {
    top: 6rem;
    left: 11.6rem;
  }
`
const StyledCloseIcon = styled(CloseIcon)`
  width: 100%;
  height: 2px;
  right: 0;
  left: initial;
`

export {
  StyledWrapper,
  StyledContentWrapper,
  StyledFormFooterWrapper,
  StyledButtonWrapper,
  secondaryButton,
  buttonStyles,
  StyledSuccessWrapper,
  StyledCloseButton,
  StyledCloseIcon,
}
